export default {
  mapRightClick: {
    options: 'Opțiuni',
    addDestinationToRoute: 'Adăugați ca destinație',
    directionsToHere: 'Direcții spre aici',
    nonStopDirectionsToHere: 'Direct aici',
    addRouteStop: 'Adăugați stop aici',
    centerHere: 'Centrul aici',
    addAsIsochroneCenter: 'Adăugați ca centru de acces',
    inspectDataOnOSM: 'Inspectați datele pe OSM',
    directionsFromHere: 'Direcții de aici',
  }
}
